module.exports = __webpack_public_path__ + "img/24_50.9ae49e55.png";